module.exports = __webpack_public_path__ + "static/media/434142159_1145375149823521_1183904094799883865_n.2b9a6920.jpg";